import {
  ChevronUpIcon,
  EditIcon,
  IconButtonColorEnum,
  IconButtonSection,
  IconButtonSectionInternalProps,
  IconButtonSectionSizeEnum,
  ImageThumbnail,
  ImageThumbnailSizesEnum,
  TextOrientationEnum,
} from '@acceso/design-system';
import clsx from 'clsx';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ItemList } from '@/components/ItemList';
import { StateActiveInTable } from '@/components/StateActiveInTable/StateActiveInTable';
import { UserAction } from '@/components/UserAction';
import { TLogo } from '@/features/logos/types';

const internalPropsIconButtonEditUser: IconButtonSectionInternalProps = {
  icon: {
    type: EditIcon,
  },
  iconButton: {
    color: IconButtonColorEnum.NONE_DEFAULT,
  },
  text: {
    value: 'Editar',
    orientation: TextOrientationEnum.LEFT,
    className: 'text-text-dark-10 text-body-3 font-regular',
  },
};

type LogosDetailsProps = {
  logos: TLogo;
  onUpdate: (logos: TLogo) => void;
};

export function LogosDetail({ logos, onUpdate }: LogosDetailsProps) {
  const { t } = useTranslation();

  const [open, setOpen] = useState(false);

  return (
    <div className="flex flex-1 flex-col items-start self-stretch">
      <div className="flex items-start justify-end self-stretch">
        <IconButtonSection
          onClick={() => onUpdate(logos)}
          internalProps={internalPropsIconButtonEditUser}
          size={IconButtonSectionSizeEnum.LG}
        />
      </div>
      <div className="flex w-full flex-col divide-y divide-stroke-20">
        <ItemList title={t('Logotipos')}>
          <ImageThumbnail
            size={ImageThumbnailSizesEnum.Xxl}
            src={logos.parameters?.main_logo_presigned_url}
          />
        </ItemList>
        <ItemList title={t('Marca')}>{logos.name}</ItemList>
        <ItemList title={t('Alias')}>{logos.alias}</ItemList>
        <ItemList title={t('Descripción')}>{logos.description}</ItemList>
        <ItemList title={t('Estado')}>
          <StateActiveInTable status={logos.state} />
        </ItemList>
        <ItemList title={t('Referencias IA')}>
          <button
            className="flex w-full items-center justify-between outline-none"
            type="button"
            onClick={() => {
              setOpen(!open);
            }}
          >
            <ChevronUpIcon
              className={clsx(
                'mr-size-8 transition-transform duration-500',
                !open ? '-rotate-180' : 'rotate-0'
              )}
            />
          </button>
        </ItemList>
        {open && (
          <div className="flex border-separate items-center gap-2 p-2">
            {logos.parameters?.logos_presigned_urls?.map(logo => (
              <ImageThumbnail src={logo} size={ImageThumbnailSizesEnum.Xxl} />
            ))}
          </div>
        )}

        <ItemList title={t('Creado por')}>
          <UserAction
            id={logos?.created_by || new Date().toISOString()}
            timestamp={logos?.created_at || new Date().toISOString()}
          />
        </ItemList>
        <ItemList title={t('Actualizado por')}>
          <UserAction
            id={logos?.updated_by || logos?.created_by || new Date().toISOString()}
            timestamp={logos?.updated_at || logos?.created_at || new Date().toISOString()}
          />
        </ItemList>
      </div>
    </div>
  );
}
